export const CloudSync = (): JSX.Element => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 5C4 2.79086 5.79086 1 8 1C9.4806 1 10.7733 1.80444 11.4649 3.00009L11.5 3C11.8837 3 12.2597 3.03325 12.6251 3.09703C11.8765 1.27946 10.0877 0 8 0C5.23858 0 3 2.23858 3 5V5.03544C1.30385 5.27806 0 6.73676 0 8.5C0 10.433 1.567 12 3.5 12C3.77614 12 4 11.7761 4 11.5C4 11.2239 3.77614 11 3.5 11C2.11929 11 1 9.88071 1 8.5C1 7.11929 2.11929 6 3.5 6C3.77614 6 4 5.77614 4 5.5V5Z"
      fill="#46597C"
    />
    <path
      d="M10.6464 4.14645C10.8417 3.95118 11.1583 3.95118 11.3536 4.14645L12.8536 5.64644C12.9473 5.74021 13 5.86739 13 6C13 6.13261 12.9473 6.25978 12.8536 6.35355L11.3536 7.85355C11.1583 8.04881 10.8417 8.04881 10.6464 7.85355C10.4512 7.65829 10.4512 7.34171 10.6464 7.14644L11.2929 6.5H11C10.4067 6.5 9.82664 6.67595 9.33329 7.00559C8.83994 7.33523 8.45543 7.80377 8.22836 8.35195C8.0013 8.90013 7.94189 9.50333 8.05765 10.0853C8.1734 10.6672 8.45912 11.2018 8.87868 11.6213C9.07394 11.8166 9.07394 12.1332 8.87868 12.3284C8.68342 12.5237 8.36684 12.5237 8.17157 12.3284C7.61216 11.769 7.2312 11.0563 7.07686 10.2804C6.92252 9.50444 7.00173 8.70017 7.30448 7.96926C7.60723 7.23836 8.11992 6.61365 8.77772 6.17412C9.43552 5.73459 10.2089 5.5 11 5.5H11.2929L10.6464 4.85355C10.4512 4.65829 10.4512 4.34171 10.6464 4.14645Z"
      fill="#46597C"
    />
    <path
      d="M14.1213 6.67184C14.3166 6.47657 14.6332 6.47657 14.8284 6.67184C15.3878 7.23125 15.7688 7.94398 15.9231 8.7199C16.0775 9.49583 15.9983 10.3001 15.6955 11.031C15.3928 11.7619 14.8801 12.3866 14.2223 12.8261C13.5645 13.2657 12.7911 13.5003 12 13.5003L11.7073 13.5002L12.3536 14.1464C12.5488 14.3417 12.5488 14.6583 12.3536 14.8536C12.1583 15.0488 11.8417 15.0488 11.6464 14.8536L10.1464 13.3536C9.95119 13.1583 9.95119 12.8417 10.1464 12.6464L11.6464 11.1464C11.8417 10.9512 12.1583 10.9512 12.3536 11.1464C12.5488 11.3417 12.5488 11.6583 12.3536 11.8536L11.7069 12.5002L12 12.5003C12.5933 12.5002 13.1734 12.3243 13.6667 11.9947C14.1601 11.665 14.5446 11.1965 14.7716 10.6483C14.9987 10.1001 15.0581 9.49693 14.9424 8.91499C14.8266 8.33305 14.5409 7.7985 14.1213 7.37894C13.9261 7.18368 13.9261 6.8671 14.1213 6.67184Z"
      fill="#46597C"
    />
  </svg>
);

export const CloudCheck = (): JSX.Element => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 1C5.79086 1 4 2.79086 4 5V5.5C4 5.77614 3.77614 6 3.5 6C2.11929 6 1 7.11929 1 8.5C1 9.88071 2.11929 11 3.5 11C3.77614 11 4 11.2239 4 11.5C4 11.7761 3.77614 12 3.5 12C1.567 12 0 10.433 0 8.5C0 6.73676 1.30385 5.27806 3 5.03544V5C3 2.23858 5.23858 0 8 0C10.1267 0 11.9432 1.32772 12.666 3.19947C12.2802 3.10528 11.8819 3.04307 11.474 3.01579C10.7846 1.81149 9.48707 1 8 1Z"
      fill="#46597C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 10C16 12.7614 13.7614 15 11 15C8.23858 15 6 12.7614 6 10C6 7.23858 8.23858 5 11 5C13.7614 5 16 7.23858 16 10ZM13.95 7.9C14.2814 8.14853 14.3485 8.61863 14.1 8.95L11.1 12.95C10.9695 13.1239 10.77 13.2327 10.5532 13.2481C10.3363 13.2635 10.1234 13.1841 9.96967 13.0303L7.96967 11.0303C7.67678 10.7374 7.67678 10.2626 7.96967 9.96967C8.26256 9.67678 8.73744 9.67678 9.03033 9.96967L10.4189 11.3582L12.9 8.05C13.1485 7.71863 13.6186 7.65147 13.95 7.9Z"
      fill="#46597C"
    />
  </svg>
);

export const CloudSlash = (): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.853553 0.146447C0.658291 -0.0488155 0.341709 -0.0488155 0.146447 0.146447C-0.0488155 0.341709 -0.0488155 0.658291 0.146447 0.853553L15.1464 15.8536C15.3417 16.0488 15.6583 16.0488 15.8536 15.8536C16.0488 15.6583 16.0488 15.3417 15.8536 15.1464L0.853553 0.146447Z"
      fill="#46597C"
    />
    <path
      d="M3.00375 7C3.00375 6.64252 3.04208 6.28899 3.11646 5.94489L4.00833 6.83676C4.00612 6.89104 4.005 6.94546 4.005 7H4.17157L5.17157 8H3.56445C3.52749 8.00443 3.49024 8.00475 3.45338 8.00101C2.81527 8.01908 2.20709 8.28014 1.75443 8.73223C1.285 9.20107 1.02128 9.83696 1.02128 10.5C1.02128 11.163 1.285 11.7989 1.75443 12.2678C2.22385 12.7366 2.86053 13 3.52441 13H10.1716L11.1716 14H3.50438C2.57496 14 1.68361 13.6313 1.02641 12.9749C0.36921 12.3185 7.45058e-09 11.4283 7.45058e-09 10.5C7.45058e-09 9.57174 0.36921 8.6815 1.02641 8.02513C1.564 7.48821 2.25827 7.14375 3.0019 7.03615L3.00375 7Z"
      fill="#46597C"
    />
    <path
      d="M15.0188 10.5C15.0188 10.9686 14.8871 11.4236 14.6441 11.8157L15.3537 12.5253C15.7714 11.9374 16 11.2304 16 10.5C16 9.57174 15.6308 8.6815 14.9736 8.02513C14.4409 7.49306 13.7543 7.15 13.0183 7.03913L13.0163 7C13.0163 5.67392 12.4888 4.40215 11.55 3.46447C10.6111 2.52678 9.33775 2 8.01001 2C7.12148 2 6.2573 2.23591 5.50143 2.673L6.24018 3.41175C6.78567 3.14338 7.39044 3 8.01001 3C9.0722 3 10.0909 3.42143 10.842 4.17157C11.5931 4.92172 12.015 5.93913 12.015 7C12.0253 7.14649 12.0253 7.29351 12.015 7.44C12 7.56786 12.034 7.69663 12.1102 7.8005C12.1863 7.90436 12.299 7.97563 12.4255 8H12.4856C12.5017 8.00078 12.5178 8.0008 12.5337 8.00007C13.1911 8.00481 13.8205 8.26765 14.2856 8.73223C14.7551 9.20107 15.0188 9.83696 15.0188 10.5Z"
      fill="#46597C"
    />
  </svg>
);
